import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useProjectStore } from './store/useProjectStore';
import { useAuthStore } from './store/useAuthStore';
import { HomeScreen } from './components/HomeScreen';
import { ProjectView } from './components/ProjectView';
import { LoginScreen } from './components/auth/LoginScreen';
import { InternalAdmin } from './components/InternalAdmin';
import { UsagePage } from './components/UsagePage';

export default function App() {
  // Auth state
  const authUser = useAuthStore((s) => s.user);
  const authLoading = useAuthStore((s) => s.loading);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  // Check auth on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (authLoading) {
    return <div style={{ color: '#E8EAF0', padding: 20 }}>Loading...</div>;
  }

  if (!authUser) {
    return <LoginScreen />;
  }

  return (
    <>
      <Toast />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/internal" element={<InternalAdmin />} />
        <Route path="/usage" element={<UsagePage />} />
        {/* Project routes — the tab lives in the path. A bare /p/{id}
            redirects to the default tab (resolved inside ProjectView). */}
        <Route path="/p/:projectId" element={<ProjectView />} />
        <Route path="/p/:projectId/:tab" element={<ProjectView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function Toast() {
  const toast = useProjectStore((s) => s.toast);
  const setToast = useProjectStore((s) => s.setToast);
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  const [type, setType] = useState<'success' | 'error' | 'info'>('info');
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (toast) {
      setText(toast.message);
      setType(toast.type || 'info');
      setVisible(true);
      clearTimeout(timerRef.current);
      const duration = toast.type === 'error' ? 5000 : 3000;
      timerRef.current = setTimeout(() => {
        setVisible(false);
        setTimeout(() => setToast(null), 300);
      }, duration);
    }
    return () => clearTimeout(timerRef.current);
  }, [toast, setToast]);

  if (!text) return null;

  return (
    <div className={`transition-toast toast-${type} ${visible ? 'toast-in' : 'toast-out'}`}>
      {text}
    </div>
  );
}
